import type { ContenidoAyuda, ItemAyuda } from "@/ui/AyudaVista";
import {
  BOTONES_CORREOS_IA,
  FICHAS_CORREOS_IA,
  botonesApuntesYEvidencias,
} from "./redaccionComun";

/**
 * Ayuda de «Responderle a <proveedor>» (`components/ResponderProveedorModal`),
 * en sus dos modos: contestar en el ticket vivo, o abrir un ticket de
 * SEGUIMIENTO porque el proveedor cerró el suyo (solo Queclink).
 */
export function ayudaResponderProveedor({
  proveedor,
  ticket,
  seguimiento,
  puedeSeguimiento,
  iaHabilitada,
  puedeTraducir,
}: {
  proveedor: string;
  ticket: string;
  /** La ventana está en modo «ticket de seguimiento». */
  seguimiento: boolean;
  /** Este proveedor tiene el camino de seguimiento (Queclink). */
  puedeSeguimiento: boolean;
  iaHabilitada: boolean;
  /** Sale «Pasarlo a inglés» (Jimi, con la IA habilitada). */
  puedeTraducir: boolean;
}): ContenidoAyuda {
  const botones: ItemAyuda[] = [];
  if (iaHabilitada) {
    botones.push({
      label: "✨ Redactar con IA",
      text: `Redacta ${seguimiento ? "el mensaje" : "la respuesta"} con el contexto del caso: las notas de la bitácora, los contactos, los equipos, lo que ya se escribió en el ticket y los correos que marques. Lo que ya escribiste sirve de guía. Reemplaza el texto de la caja sin preguntar: revísalo antes de mandarlo. Necesita al menos una nota escrita a mano en la bitácora.`,
    });
  }
  if (puedeTraducir) {
    botones.push({
      label: "🌐 Pasarlo a inglés",
      text: "Opcional: el técnico de Jimi lee bien en español. Si prefieres mandarlo en inglés, la IA traduce lo que escribiste y lo deja en la caja para que lo revises. No manda nada. Sale gris con la caja vacía.",
    });
  }
  botones.push(...botonesApuntesYEvidencias("la respuesta"));
  if (iaHabilitada) botones.push(...BOTONES_CORREOS_IA);
  botones.push(
    {
      label: seguimiento ? "Abrir ticket de seguimiento" : "Enviar",
      text: "Todavía no manda nada: te pide confirmar. Sale gris con la caja vacía o mientras la IA trabaja.",
    },
    {
      label: seguimiento ? "Sí, abrir el ticket de seguimiento" : `Sí, mandarlo a ${proveedor}`,
      text: `Ahora sí ${seguimiento ? "lo abre" : "lo manda"}, tal cual está escrito, y queda también en la bitácora del caso. Si cambias el texto, vuelve a pedir confirmación.`,
    },
    { label: "Cancelar", text: "Cierra sin mandar. Lo que escribiste se pierde." },
  );

  let intro: string;
  if (seguimiento) {
    intro = `${proveedor} cerró el ticket ${ticket} y ya no acepta respuestas. Lo que escribas aquí abre un ticket nuevo en su sistema, ligado al anterior. No se puede borrar ni editar después.`;
  } else {
    intro = `Contesta en el ticket ${ticket} de ${proveedor} sin salir del caso. Se escribe en el sistema de ${proveedor} y no se puede borrar ni editar después.`;
    if (puedeSeguimiento) {
      intro += ` Si al mandarlo resulta que ${proveedor} ya cerró el ticket, no se manda nada: la ventana cambia sola a «ticket de seguimiento» y tu texto se queda.`;
    }
  }

  return {
    manual: "jimi",
    intro: <p>{intro}</p>,
    secciones: [
      { titulo: "Qué hace cada botón", items: botones },
      { titulo: "Qué significa cada indicador", items: iaHabilitada ? FICHAS_CORREOS_IA : [] },
    ],
  };
}
